.breakable {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}
